<template>
  <div>
    <v-card class="saved-day-card">
      <v-card-title><h4>{{ dayName }}</h4></v-card-title>
      <v-divider />
      <v-list dense>
        <v-subheader>Sriubos</v-subheader>
        <v-list-tile v-for="(soup, index) in soups" :key="`soup-${index}`" class="list-tile" @click="{}">
          <v-list-tile-content>{{ soup.name }}</v-list-tile-content>
          <v-list-tile-action>{{ soup.price }} €</v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-divider />
      <v-subheader>Pagrindiniai patiekalai</v-subheader>
      <v-list dense>
        <v-list-tile v-for="(main, index) in mains" :key="`main-${index}`" class="list-tile" @click="{}">
          <v-list-tile-content>{{ main.name }}</v-list-tile-content>
          <v-list-tile-action>{{ main.price }} €</v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SavedDayCard',
  props: {
    dayName: {
      type: String,
      default: '',
    },
    soups: {
      type: Array,
      default: () => [],
    },
    mains: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
  div >>> .list__tile {
    -webkit-user-select: unset;
    -moz-user-select: unset;
    -ms-user-select: unset;
    user-select: unset;
    cursor: unset;
  }

  @media print {
    .saved-day-card {
      border: 1px solid black;
      box-shadow: none;
    }

    .divider {
      border: 0.5px solid black;
    }

    .subheader {
      font-weight: bold;
      font-size: 1.2em;
    }

    .list-tile:nth-child(even) {
      background-color: rgba(204, 204, 204, 0.25);
      -webkit-print-color-adjust: exact;
    }

    .list-tile >>> .list__tile {
      height: 20px;
    }

    .subheader {
      height: 25px;
    }

    .card__title {
      height: 30px;
      font-size: 1.4em;
    }
  }
</style>
